
import React, { } from "react";
import { Row, Column } from 'react-foundation';

import closeHandle from "images/icon-close-handle.svg";
import ChipsGrid from './ChipsGrid';
import utils from '../utils';
import ImgWithSrcset from './ImgWithSrcset';


const HandleTypeComponent = ({ onTypeClick, type, src, selectedHandleType, children }) => {

    let shownClass = !selectedHandleType ? "" : selectedHandleType === type ? " selected" : " not-shown";

    return (
        <div>
            <Column className={"handle-type" + shownClass} medium={4} showFor="medium">
                <div style={{ position: "relative" }}>
                    <ImgWithSrcset src={src} alt="" onClick={onTypeClick(type)} />
                    <img
                        className="handle-type-close"
                        onClick={onTypeClick(null)}
                        src={closeHandle}
                        alt="Close"
                    />
                    <div>{children}</div>
                </div>
            </Column>
            <Column
                className={"handle-type-label end " + shownClass}
                onClick={onTypeClick(type)}
                small={4}
                showOnlyFor={"small"}
            >
                {children}
            </Column>
        </div>
    );
};

const filterHandles = (handles, type) => {
    return handles.filter(handle => {
        if (!type) return false;

        return handle.description2 === type;
    });
};

const HandleSelector = (props) => {

    let { handles, HandleType, HandleId, selectedColour, addPreviousPreviews, useAltBestMatch, previousSelectionHandleColour, hideHandleType } = props;

    // get the handletypes from the list of handles, then make them unique
    let handleTypes = handles.map(handle => ({ name: handle.description2, imageUrl: handle.externalImageUrl2 }));
    handleTypes = handleTypes.filter((value, index) => handleTypes.map(h => h.name).indexOf(value.name) === index);

    let allHandles = handles.slice(0);

    let onTypeClick = type => () => {
        HandleType.input.onChange(type);
        let newId = null;

        if (type !== null) {
            let handleByType = filterHandles(allHandles, type);
            newId = utils.findHandleByColour(handleByType, previousSelectionHandleColour, type) || utils.getExtraBestMatch(handleByType, selectedColour, useAltBestMatch);
        }
        HandleId.input.onChange(newId);
        props.addPreviousPreviews(newId);
    };

    handles = filterHandles(handles, HandleType.input.value);


    return (
        <Row style={{ position: "relative" }} className={hideHandleType ? "hide-handle-type" : ""}>
            {
                handleTypes.map((handleType) => (
                    <HandleTypeComponent
                        selectedHandleType={HandleType.input.value}
                        onTypeClick={onTypeClick}
                        src={handleType.imageUrl}
                        type={handleType.name}
                        key={handleType.name}
                    >
                        {handleType.name}
                    </HandleTypeComponent>
                )
                )
            }

            <Column
                className={"handle-colours" + (HandleType.input.value ? "" : " not-shown")}
                medium={hideHandleType ? 12 : 8}
            >
                <Row isColumn>
                    <ChipsGrid
                        key={HandleType.input.value}
                        colours={handles}
                        selectedId={HandleId.input.value}
                        onChange={id => {
                            addPreviousPreviews(id);
                            HandleId.input.onChange(id);
                        }}
                    />
                </Row>
            </Column>
        </Row>
    );
}


export default HandleSelector;


// WEBPACK FOOTER //
// ./src/components/HandleSelector.js